import React from 'react';

import pluralize from 'pluralize';

import SelectAllCheckbox from './select_all_checkbox';

import type { Props } from './types';

export default function MapListHeaderEdgeCrm({ toggleSelectAll, totalCount, totalLabel, ...props }: Props) {
  return  (
    <div className="d-flex p-3 pr-4 border-bottom border-right">
      <SelectAllCheckbox toggleSelectAll={toggleSelectAll} {...props} />
      <div className="flex-1">
        <span className="clickable" onClick={toggleSelectAll}>
          Select all
        </span>
      </div>
      <div>
        {pluralize(totalLabel, totalCount, true)}
      </div>
    </div>
  );
}
